// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

BCSfFilter.prototype.prepareSearchParams = function(params, eventType) {
    if (this.isSearchPage()) {
        params['q'] = this.getSearchTerm();
        if (this.searchTermKey != 'q') delete params[this.searchTermKey];
        var enableFuzzy = this.getSettingValue('search.enableFuzzy');
        if (enableFuzzy !== true ) params.fuzzy = enableFuzzy;
        if (this.getSettingValue('search.reduceMinMatch') !== false) {
            params.reduce_min_match = this.getSettingValue('search.reduceMinMatch');
        }
        if (this.getSettingValue('search.fullMinMatch')) params.full_min_match = true;
        if (this.getSettingValue('general.sortingAvailableFirst')) params.sort_first = 'available';
        if (this.getSettingValue('search.enablePlusCharacterSearch')) params.enable_plus_character_search = true;
    }
  	params.boost = true;
    return params;
};

// Prepare Params of Suggestion API
BCSfFilter.prototype.prepareSuggestionParams = function(searchTerm, eventType) {
    var params = {};
    params.shop = this.shopDomain;
    params.t = new Date().getTime();
    if (!this.getSettingValue('search.enableDefaultResult')) params.enable_default_result = false;
    var enableFuzzy = this.getSettingValue('search.enableFuzzy');
    if (enableFuzzy !== true ) params.fuzzy = enableFuzzy;
    if (this.getSettingValue('search.fullMinMatch')) params.full_min_match = true;
    if (this.getSettingValue('search.reduceMinMatch') !== false) {
      params.reduce_min_match = this.getSettingValue('search.reduceMinMatch');
    }
    if (this.getSettingValue('search.enablePlusCharacterSearch')) params.enable_plus_character_search = true;
    // Get product/variant available or not
    if (this.getSettingValue('search.productAvailable') == true) params.product_available = true;
    // Limit
    var blocks = this.getSettingValue('search.suggestionBlocks');
    var k;
    var blocksLength = blocks.length;
    for (k = 0; k < blocksLength; k++) {
        var id = blocks[k]['type'].slice(0, -1);
        params[id + '_limit'] = blocks[k]['number'];
    }
    params['dym_limit'] = this.getSettingValue('search.suggestionDymLimit');
    // Skip fields
    var skipFields = this.getSettingValue('search.skipFields');
    if (skipFields.length > 0) param.skipFields = skipFields;
    params.callback = 'BCSfSuggestionCallback';
    params.event_type = eventType;
    // Suggest types
    var suggestionTypes = eventType == 'suggest_dym' ? ['products'] : this.getSettingValue('search.suggestionTypes');
    params.suggest_types = suggestionTypes;
  	params.boost = true;
    return params;
};
